import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import {  contactSchema } from "../../schema";
import {  contactUsApi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const initialValues = {
  email: "",
  name: "",
  subject: "",
  message: ""
};

export const ContactUs = () => {
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (values, action) => {
    setIsLoading(true);
    contactUsApi(values)
      .then((response) => {
        setIsLoading(false);
        toast.current.show({
          severity: "success",
          summary: `${response?.data?.message}`,
        });
        action.resetForm();
      })
      .catch((err) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: `${err?.response?.data?.message}`,
        });
      });
  };



  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: contactSchema,
      onSubmit: (values, action) => submit(values, action),
    });

  return (
    <>
      <div className="all-login-signup-forgot-pass-model">
        <Toast ref={toast} />

        {isLoading && (
          <div class="set-proper-line-in-all-page">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        )}

        <div className="loop-text-cls-add">
          <h1>The Loop</h1>
        </div>
        <div class="auth_screen">
          <div class="row">
            <div class="col-lg-12">
              <div class="auth_box">
                <div class="auth_body mt-4 w-100">
                  <h6 class="mb-4">Contact-us</h6>
                  <form onSubmit={handleSubmit} class="">
                    <div class="form-content">
                      <div class="form-group">
                        <label class="form-label all-label-same">Name</label>
                        <input
                          type="text"
                          name="name"
                          class="form-control input-underline input-lg"
                          placeholder="Enter Your Name "
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.name && touched?.name ? (
                          <p className="form-error">{errors.name}</p>
                        ) : null}

                      <label class="form-label all-label-same mt-2">Email</label>
                        <input
                          type="email"
                          name="email"
                          maxlength="50"
                          class="form-control input-underline input-lg"
                          placeholder="Enter Your Email Id "
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.email && touched?.email ? (
                          <p className="form-error">{errors.email}</p>
                        ) : null}

                      <label class="form-label all-label-same mt-2">Subject</label>
                        <input
                          type="text"
                          name="subject"
                          class="form-control input-underline input-lg"
                          placeholder="Your Subject "
                          value={values.subject}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.subject && touched?.subject ? (
                          <p className="form-error">{errors.subject}</p>
                        ) : null}


                      <label class="form-label all-label-same mt-2">Message</label>
                        <input
                          type="textarea"
                          name="message"
                          class="form-control input-underline input-lg"
                          placeholder="Your Message "
                          value={values.message}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors?.message && touched?.message ? (
                          <p className="form-error">{errors.message}</p>
                        ) : null}
                      </div>
                      
                      <div class="user_link mt-2">                       
                        <div class="row mt-4 mb-2">
                          <div class="col-lg-12 text-center">
                            <button
                              type="submit"
                              class="btn fill_btn same-all-btn-primary"
                              // onClick={handleLogin}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
